import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT

function* get_NavigationList(actions) {

  let uuid = actions.idUser ? actions.idUser : getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid
    };

    const requestOptions = {
      headers: headers
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-categories?page=" + actions.page
        : apiUrl + "/opa-categories" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);


    yield put({ type: "LIST_NAVIGATION_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_NAVIGATION_RESPONSE_GET", value: error });
  }
}


function* get_Navigation(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-category/"
        : `${apiUrl}/opa-category/${actions.query}`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response) {
        responseStatus = "success";
      } else {
        responseStatus = response;
      }
    }

    yield put({ type: "PRODUCT_NAVIGATION_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "PRODUCT_NAVIGATION_RESPONSE_GET", value: error });
  }
}


function* add_Navigation(actions) {
  let uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${actions.access}`,
      "X-RealmUuid": uuid
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form)
    };


    let url = apiUrl + "/opa-category";

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    yield put({
      type: "NAVIGATION_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({ type: "NAVIGATION_RESPONSE_ADD", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* edit_Navigation(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-category/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }
    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "NAVIGATION_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "NAVIGATION_RESPONSE_EDIT",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* edit_NavigationList(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-category/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "NAVIGATION_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "NAVIGATION_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteNavigation(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-category/" + actions.uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "NAVIGATION_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "NAVIGATION_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }

}


export function* getNavigationList() {
  yield takeEvery("GET_NAVIGATION_LIST", get_NavigationList);
}

export function* getNavigation() {
  yield takeEvery("GET_NAVIGATION", get_Navigation);
}

export function* addNavigation() {
  yield takeEvery("ADD_NAVIGATION", add_Navigation);
}

export function* editNavigation() {
  yield takeEvery("EDIT_NAVIGATION", edit_Navigation);
}


export function* editNavigationList() {
  yield takeEvery("EDIT_NAVIGATION_LIST", edit_NavigationList);
}

export function* deleteNavegationSaga() {
  yield takeEvery("DELETE_NAVEGATION", deleteNavigation);
}


const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};